import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCart, CheckCircle2, Gift } from 'lucide-react';
import { Countdown } from './Countdown';
const proBonos = ['Sistema de pases definitivo', 'Psicología deportiva', 'Calculadora de proteínas e hidratación'];
const checklist = ['Manual del Enganche (6 tomos)', 'Sistema de Tiros Libres (4 tomos)', 'Bono 1: Planificador Semanal Integrado', 'Bono 2: Programa de Velocidad', 'Bono 3: Estrategia de Formaciones', 'Bono Pro: Sistema de pases definitivo', 'Bono Pro: Psicología deportiva', 'Bono Pro: Calculadora de proteínas e hidratación'];
export function Compra() {
  const handlePurchase = () => {
    window.open('https://checkout.ebookpoint.shop/cart/59670603235409:1', '_blank');
  };
  return <section id="compra" className="bg-white py-16 md:py-24" data-id="element-30">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-31">
        {/* Bono Exclusivo Por Hoy */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gray-900 rounded-2xl p-8 md:p-10 text-white shadow-xl mb-12 border border-emerald-500/30 relative overflow-hidden" data-id="element-32">
          <div className="absolute top-0 right-0 w-64 h-64 bg-emerald-600/20 rounded-full blur-3xl -mr-20 -mt-20 pointer-events-none" data-id="element-33" />

          <div className="relative z-10" data-id="element-34">
            <div className="flex items-center gap-3 mb-8 justify-center" data-id="element-35">
              <Gift className="w-8 h-8 text-emerald-400" data-id="element-36" />
              <h3 className="text-2xl md:text-3xl font-bold text-center" data-id="element-37">
                Bono exclusivo por hoy
              </h3>
            </div>

            <div className="grid md:grid-cols-3 gap-4 mb-6" data-id="element-38">
              {proBonos.map((bono, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="bg-white/10 backdrop-blur-md rounded-xl p-5 border border-white/10 flex flex-col items-center text-center gap-3" data-id="element-39">
                  <div className="w-10 h-10 rounded-full bg-emerald-500/20 flex items-center justify-center" data-id="element-40">
                    <CheckCircle2 className="w-6 h-6 text-emerald-400" data-id="element-41" />
                  </div>
                  <span className="font-semibold text-emerald-50" data-id="element-42">
                    Bono Pro:
                    <br data-id="element-43" />
                    {bono}
                  </span>
                </motion.div>)}
            </div>

            <p className="text-emerald-400 text-center font-bold text-lg uppercase tracking-wider" data-id="element-44">
              🎁 GRATIS por el día de hoy
            </p>
          </div>
        </motion.div>

        {/* Oferta Final */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-b from-emerald-600 to-emerald-800 rounded-3xl p-1 md:p-2 shadow-2xl" data-id="element-45">
          <div className="bg-white rounded-2xl p-8 md:p-12" data-id="element-46">
            <h2 className="text-3xl md:text-4xl font-black text-center text-gray-900 mb-8" data-id="element-47">
              Acceso Inmediato al Sistema Completo
            </h2>

            <div className="mb-8 rounded-2xl overflow-hidden" data-id="element-48">
              <Countdown data-id="element-49" />
            </div>

            <div className="grid md:grid-cols-2 gap-10 items-center" data-id="element-50">
              {/* Checklist */}
              <div className="space-y-3" data-id="element-51">
                <h4 className="font-bold text-xl text-gray-900 mb-4 border-b pb-2" data-id="element-52">
                  ¿Qué incluye tu acceso?
                </h4>
                {checklist.map((item, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-53">
                    <CheckCircle2 className="w-5 h-5 text-emerald-600 flex-shrink-0 mt-0.5" data-id="element-54" />
                    <span className={`text-gray-700 ${item.includes('Pro') ? 'font-semibold text-emerald-700' : ''}`} data-id="element-55">
                      {item}
                    </span>
                  </div>)}
              </div>

              {/* Pricing & CTA */}
              <div className="flex flex-col items-center justify-center bg-gray-50 rounded-2xl p-8 border border-gray-100" data-id="element-56">
                <div className="text-center mb-6" data-id="element-57">
                  <p className="text-gray-500 font-medium mb-1" data-id="element-58">
                    Precio regular:
                  </p>
                  <p className="text-2xl line-through text-red-500/70 font-semibold mb-2" data-id="element-59">
                    $78.990
                  </p>

                  <div className="bg-emerald-100 text-emerald-800 px-4 py-1 rounded-full text-sm font-bold inline-block mb-4" data-id="element-60">
                    OFERTA ESPECIAL
                  </div>
                  <p className="text-5xl md:text-6xl font-black text-gray-900" data-id="element-61">
                    $25.399
                  </p>
                </div>

                <button onClick={handlePurchase} className="w-full bg-emerald-600 text-white font-bold text-xl py-5 rounded-xl shadow-[0_8px_30px_rgb(5,150,105,0.3)] hover:bg-emerald-700 transition-all duration-300 transform hover:-translate-y-1 flex items-center justify-center gap-3" data-id="element-62">
                  <ShoppingCart className="w-6 h-6" data-id="element-63" />
                  Comprar Ahora
                </button>

                <div className="text-center text-gray-600 text-sm mt-6 font-medium flex flex-col gap-2" data-id="element-64">
                  <span data-id="element-65">⚡ Acceso inmediato</span>
                  <span data-id="element-66">🎁 Todos los bonos incluidos</span>
                  <span data-id="element-67">🛡️ Garantía de satisfacción</span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}